import { render, staticRenderFns } from "./tyyScoreList.vue?vue&type=template&id=0713cc7e&"
import script from "./tyyScoreList.vue?vue&type=script&lang=js&"
export * from "./tyyScoreList.vue?vue&type=script&lang=js&"
import style0 from "./tyyScoreList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports